/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, time: NonNullable<unknown> }} Irrigation_Run_StartedInputs */

const vi_irrigation_run_started = /** @type {(inputs: Irrigation_Run_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã bật bơm ${i?.name}, sẽ tự tắt lúc ${i?.time}.`)
};

/**

* @param {Irrigation_Run_StartedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_started = /** @type {((inputs: Irrigation_Run_StartedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_StartedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_started(inputs)
});